module.exports = __webpack_public_path__ + "static/media/2.question_loop.d5e3fd59.mp4";